/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CreateFormPage = lazyLoad(
  () => import('./index'),
  module => module.CreateFormPage
);
